import { render, staticRenderFns } from "./LinkCardsSection.vue?vue&type=template&id=74193f54&scoped=true&"
import script from "./LinkCardsSection.vue?vue&type=script&lang=js&"
export * from "./LinkCardsSection.vue?vue&type=script&lang=js&"
import style0 from "./LinkCardsSection.vue?vue&type=style&index=0&id=74193f54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74193f54",
  null
  
)

export default component.exports